import { useCalendarDate, useParameter } from "../../../shared";

export function useSlideSubtitle(): string {
  const [startDateId] = useParameter<number>("@start_date");
  const startDate = useCalendarDate(startDateId);

  const formatterFull = Intl.DateTimeFormat('en-US', {day: 'numeric', month: 'long', year: 'numeric' });
  const formatterMonth = Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  const formatterYear = Intl.DateTimeFormat('en-US', { year: 'numeric' });

  if (!startDate) return "";
  let formattedDate = "";
  switch(+String(startDateId)[0]) {
    case 1:
      formattedDate = formatterYear.format(startDate);
      break;
    case 4:
      formattedDate = formatterMonth.format(startDate);
      break;
    default:
      formattedDate = formatterFull.format(startDate);
  };

  return `Development of most important Commodities since ${formattedDate}`;
}